module.exports = __webpack_public_path__ + "static/image/history/pc/202210.jpg?6bb097aa";